import PropTypes from 'prop-types';
import React from 'react';
import './SearchBar.scss';

function SearchBar(props) {
  const {value, placeholder, onChange} = props;

  return (
    <div className="search-bar">
      <div className="menu-input">
        <input id="search-bar" type="text" placeholder={placeholder} value={value} onChange={onChange} />
      </div>
    </div>
  );
}

SearchBar.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

SearchBar.defaultProps = {
  value: '',
  placeholder: '',
  onChange: () => {},
};

export default SearchBar;
